import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const AdminLayout = () => {
  return (
    <div className="cms-layout">

      <Sidebar />

      <main className="cms-main">

        <header className="cms-topbar">

          <div>
            <h1>IndiaBoats CMS</h1>
            <p>
              Manage your website content
            </p>
          </div>

          <div className="cms-admin-info">
            <div className="cms-admin-avatar">
              A
            </div>

            <div>
              <strong>Administrator</strong>
              <span>Admin</span>
            </div>
          </div>

        </header>

        <div className="cms-content">
          <Outlet />
        </div>

      </main>

    </div>
  );
};

export default AdminLayout;